import moment from 'moment'
import {mapActions,mapState} from 'vuex'
import CloseSessionAlertModal from '@/components/modals/CloseSessionAlertModal'
import {TIME_LOCAL_PAGE_TIMER} from '../constants'

export default {
    data() {
        return {
            interval : null
        }
    },
    components : {
        CloseSessionAlertModal
    },
    computed : {
        ...mapState(['localPageTimer'])
    },
    methods: {
        ...mapActions(['setLocalPageTimer']),
        async updateLocalPageTimer(){
            await this.setLocalPageTimer(TIME_LOCAL_PAGE_TIMER);
            this.interval = setInterval(()=>{
                this.setLocalPageTimer(
                    moment(this.localPageTimer,'mm:ss').subtract(1,"second").format('mm:ss')
                );
            },1000)
        }
    },
    beforeDestroy(){
        clearInterval(this.interval)
    },
    mounted(){
        this.updateLocalPageTimer();
    },
    watch : {
        localPageTimer(value){
            if(value === '00:30'){
                window.$('#helperSessionModal')[0].click();
            }
        }
    }
};
  